import { getConfig } from '../config/config';
import { BRAND } from '../constants';

export const buildAccountUrl = (path: string, region: string) => {
    const rootDomain = getConfig()?.rootDomain;
    const safeRegion = (region || '').toLowerCase();
    if (!rootDomain || !safeRegion) {
        return '';
    }
    return `https://account.${safeRegion}.${rootDomain}${path}`;
};

export const getCanonicalLink = (path: string) => {
    const domain = getConfig()?.domain;

    return `https://${domain}${path}`;
};

export type HreflangLinks = {
    'en-us': string;
    'en-ca': string;
    'x-default': string;
};

export const getHreflangLinks = (path: string): HreflangLinks | null => {
    const config = getConfig();

    if (process.env.BRAND !== BRAND.FANDUEL || config.seo.noIndex) {
        return null;
    }

    return {
        'en-us': `https://casino.fanduel.com${path}`,
        'en-ca': `https://casino.fanduel.ca${path}`,
        'x-default': `https://casino.fanduel.com${path}`
    };
};
